<template>
  <template v-if="mode === 'edit'">
    <div
      :class="[
        'attachment-field',
        field.error || errorMessage
          ? 'my-2 px-2 rounded border-2 border-brand-red bg-brand-red bg-opacity-10'
          : ''
      ]"
      :name="field.name"
      :field-id="field.field_id"
      :required="field.required"
    >
      <div class="flex flex-row">
        <label v-if="field.label" for="input" class="flex items-center flex-1">
          {{ field.label }}
          <span v-if="field.required" class="text-brand-red">*</span>
          <span v-if="filename" class="text-brand-mid-gray text-sm ml-2">{{
            filename.replace("form-uploads/", "")
          }}</span>
          <SmallLoading v-if="isUploadingLoading" class="ml-2" />
        </label>

        <div class="flex">
          <input
            ref="fileInput"
            type="file"
            accept="image/*,application/pdf"
            hidden
            @change="uploadFile"
            :required="field.required"
          />
          <img
            class="flex-4 cursor-pointer"
            v-show="file"
            src="@/assets/icons/trash.svg"
            @click="removeFile"
          />
          <img
            class="flex-4 cursor-pointer"
            v-show="!file"
            src="@/assets/icons/upload.svg"
            @click="$refs.fileInput.click()"
          />
        </div>
      </div>
      <div class="w-full mt-3 mb-5 border-t border-brand-mid-gray"></div>

      <template v-if="field.error || errorMessage">
        <p class="text-brand-red">{{ errorMessage }}</p>
      </template>
    </div>
  </template>

  <template v-if="mode === 'view'">
    <div class="flex flex-col md:flex-row justify-between w-full">
      <div class="flex items-center md:w-1/2 py-1 px-1">
        <p>{{ field.label }}</p>
      </div>
      <div class="flex items-center md:w-1/2 py-1 px-1">
        <div v-if="field.value" class="flex flex-row cursor-pointer" @click="downloadFile">
          <div class="flex items-center mr-1">
            <DownloadIcon v-if="!isDownloadLoading" class="text-brand-green w-5 h-5" />
            <SmallLoading v-if="isDownloadLoading" />
          </div>
          <div class="flex items-center">
            <p class="font-semibold">{{ filename }}</p>
          </div>
          <div class="flex items-center"></div>
        </div>
        <p v-else class="font-semibold">No file uploaded</p>
      </div>
    </div>
  </template>

  <template v-if="mode === 'form_edit'">
    <div class="flex flex-col w-full">
      <TextDisplayEditToggle
        :helpText="field.help_text"
        :type="'field_subtext'"
        @input="updateHelpText"
        :disabled="field.editable === false"
      />
    </div>
  </template>
</template>
<script>
import { DownloadIcon } from "@heroicons/vue/outline"
import { ATTACHMENT_UPLOAD, ATTACHMENT_DOWNLOAD } from "@/store/types"

export default {
  components: {
    DownloadIcon
  },
  props: {
    field: Object,
    mode: {
      type: String
    },
    stage: {
      type: String
    }
  },
  emits: ["update"],
  data() {
    return {
      file: null,
      filename: "",
      errorMessage: "",
      isDownloadLoading: false,
      isUploadingLoading: false
    }
  },
  computed: {
    isValid() {
      if (this.field.required && !this.field.value) {
        return false
      }
      return true
    }
  },
  mounted() {
    if (this.field.value) {
      this.filename = this.field.value.replace("form-uploads/", "")
    }
  },
  methods: {
    updateHelpText(ev) {
      // eslint-disable-next-line vue/no-mutating-props
      this.field.help_text = ev.target.value
    },
    async uploadFile(e) {
      let files = e.target.files
      if (!files) return

      if (files[0].size / (1024 * 1024) >= 6) {
        this.errorMessage = "File is over the 5mb size limit."

        setTimeout(() => {
          this.errorMessage = ""
        }, 3000)

        return
      }
      this.file = files[0]

      this.isUploadingLoading = true

      // TODO: Upload action to Rentapp API
      try {
        const response = await this.$store.dispatch(ATTACHMENT_UPLOAD, {
          file: this.file
        })
        this.filename = response.data.filenames[0]
        this.$emit("update", this.filename)
      } catch (err) {
        this.errorMessage = "File upload failed."
      }
      this.isUploadingLoading = false
    },
    async downloadFile() {
      this.isDownloadLoading = true
      await this.$store.dispatch(ATTACHMENT_DOWNLOAD, {
        path: this.field.value
      })
      this.isDownloadLoading = false
    },
    removeFile() {
      this.file = null
      this.filename = ""
      this.$refs.fileInput.value = null
      this.$emit("update", this.filename)
    },
    validateField() {
      if (!this.isValid) {
        if (this.field.required && !this.field.value) {
          this.errorMessage = "This field is required."
        }
      } else {
        this.errorMessage = ""
      }
    }
  }
}
</script>
<style lang="scss" scoped></style>
